export const onboardingLinkData = {
  id: '3b7fa215-1f1c-456c-9e19-87ec95525728',
  url: 'https://onboarding.dev.lemonway.com/paysquadverifone/3c1d00ca-1f6c-4f7b-9fcf-47a44b65eff4/welcome'
};

export const onboardingLinkResponse = {
  status: 200,
  contentType: 'application/json',
  body: JSON.stringify(onboardingLinkData)
};
